import type { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

export function ReconciliationDetailsLayout({ title, testId, children }: {
  title: ReactNode; testId: string; children: ReactNode;
}) {
  return <Stack spacing={2} sx={{ p: 2 }} data-testid={testId}>
    <Typography variant="subtitle2">{title}</Typography>
    {children}
  </Stack>;
}

export function ReconciliationSourcePanels({ children }: { children: ReactNode }) {
  return <Stack direction={{ xs: 'column', xl: 'row' }} spacing={2}>{children}</Stack>;
}

export function ReconciliationSourcePanel({ name, testId, children }: {
  name: string; testId: string; children: ReactNode;
}) {
  return <Box sx={{ flex: 1, minWidth: 0, overflowX: 'auto' }} data-testid={testId}>
    <Typography variant="h6">{name}</Typography>
    {children}
  </Box>;
}
